import {
    createContext,
    useContext,
    useEffect,
    useState,
    type ReactNode
} from 'react'

type Mode = 'light' | 'dark'

interface ThemeContextValue {
    mode: Mode
    setMode: (mode: Mode) => void
}

const ThemeContext = createContext<ThemeContextValue>({
    mode: 'light',
    setMode: () => {}
})

export function ThemeProvider({ children }: { children: ReactNode }) {
    const [mode, setMode] = useState<Mode>(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia('(prefers-color-scheme: dark)').matches
                ? 'dark'
                : 'light'
        }
        return 'light'
    })

    useEffect(() => {
        document.documentElement.classList.toggle('dark', mode === 'dark')
    }, [mode])

    return (
        <ThemeContext.Provider value={{ mode, setMode }}>
            {children}
        </ThemeContext.Provider>
    )
}

export function useThemeMode() {
    return useContext(ThemeContext)
}
